Jelly.Payments.Select_Membership = function(Parameters) {		

	// Set active class
	$(".Membership_Anchor").parent().removeClass("Selected");
	$(
			"#" + Parameters["Namespace"] + "_Membership_" + Parameters["Membership"] + "_Anchor"
	).
		parent().addClass("Selected");

	
	// Set the hidden membership input to this value
	$(
		"#" + Parameters["Namespace"] + "_Membership_Input_Finder input[name=\"Membership\"]"
	).
		val(Parameters["Membership"]).change();	
	
	// Update the manual amount input
	$(
		"#" + Parameters["Namespace"] + " .Payment .Input input"
	).
		val(Parameters["Amount"]).change();
	
};

Jelly.Payments.Select_Default_Membership = function (Namespace) {

	// Get period
	let currentPeriod = $("#" + Namespace + " .Period_Input_Finder input").val().toLowerCase();

	// Try currently selected membership
	let $selectedMembership = $("#" + Namespace + " .Membership_Item.Selected");
	if (!$selectedMembership.hasClass("show-for-" + currentPeriod)) {

		// If the current selected membership doesn't match the period, determine the 2nd displayed membership (or 1st if there's only 1)
		let $currentPeriodMatches = $("#" + Namespace + " .Membership_Item.show-for-" + currentPeriod);	
		if ($currentPeriodMatches.length){
			$selectedMembership = $($currentPeriodMatches[$currentPeriodMatches.length > 1 ? 1 : 0]);
		}
	}
	
	// Select it
	if ($selectedMembership) {
		Jelly.Payments.Select_Membership({
				Namespace: Namespace
			,	Membership: $selectedMembership.find(".Membership_Anchor").data("id")
			, 	Amount: $selectedMembership.find(".Membership_Anchor").data(currentPeriod + "-amount")
		});
	}
}